import { createAction } from 'redux-actions';

export const actionInputParser = (inputs, returnMeta = false) => {
  if (inputs === undefined) {
    return undefined;
  }
  if (inputs.meta) {
    const { meta, ...rest } = inputs;
    const payload = rest.error === undefined ? rest : rest.error;
    return returnMeta ? meta : payload;
  }
  return returnMeta ? {} : inputs;
};

export const payloadCreator = inputs => actionInputParser(inputs, false);

export const metaCreator = inputs => actionInputParser(inputs, true);

export const asyncActionSuffix = {
  REQUEST: '_REQUEST',
  SUCCESS: '_SUCCESS',
  FAILURE: '_FAILURE'
};

export class AsyncActionType {
  constructor(base) {
    this.base = base;
    this.REQUEST = this.create(asyncActionSuffix.REQUEST);
    this.SUCCESS = this.create(asyncActionSuffix.SUCCESS);
    this.FAILURE = this.create(asyncActionSuffix.FAILURE);
  }

  create(suffix) {
    return [this.base, suffix].join('');
  }
}

export const createAsyncActions = actionType => {
  if (actionType instanceof AsyncActionType === false) {
    throw new Error(`actionType "${actionType}" is not an async action`);
  }
  const request = createAction(
    actionType.REQUEST,
    payloadCreator,
    metaCreator
  );
  const success = createAction(
    actionType.SUCCESS,
    payloadCreator,
    metaCreator
  );
  const failure = createAction(
    actionType.FAILURE,
    payloadCreator,
    metaCreator
  );
  return [request, success, failure];
};
